
import React from 'react';

interface AlignedHeaderProps {
    value: string;
    width?: string;
    justify?: string;
    alignT?: string;
  }
  
const AlignedHeader: React.FC<AlignedHeaderProps> = ({ value, width, justify, alignT }) => {
    return (
      <div 
        style={{ 
          display: 'flex', 
          justifyContent: justify || 'right', 
          alignItems : alignT || 'center', 
          height: '100%',
//          paddingRight:"25px",
  
  //        backgroundColor:'lightblue',
          width: width || '90%'
        }}
      >

        {value}
        </div>
    );
  };
  
export default AlignedHeader;
  